import { getBreakpoint } from "@front/utils";
import { createComponent } from "@front/utils/alpine";
import { debounce } from "lodash-es";
import Swiper, { Navigation, SwiperOptions, EffectFade, Thumbs } from "swiper";

function toggleModal (force: boolean) {
    document.body.classList.toggle('overflow-y-hidden', force);
    document.body.classList.toggle('h-[100vh]', force);
    document.querySelector('#main')?.classList.toggle('relative', force);
    document.querySelector('#main')?.classList.toggle('z-[50]', force);
    document.querySelector('.js-product-modal-container')?.classList.toggle('z-[10]', force);
}

function magnify(img : HTMLImageElement, glass : HTMLElement, zoom : any | Number) {
    var w = 0, h = 0, bw = 0;

    glass.style.backgroundRepeat = "no-repeat";
    glass.style.backgroundColor = "#FFF";
    glass.style.backgroundSize = (img.width * zoom) + "px " + (img.height * zoom) + "px";
    bw = 3;
    w = glass.offsetWidth / 2;
    h = glass.offsetHeight / 2;

    img.addEventListener("mousemove", moveMagnifier);

    function moveMagnifier(e : Event) {
        e.preventDefault();
        var pos, x, y;

        pos = getCursorPos(e as MouseEvent);
        x = pos.x;
        y = pos.y;

        // Empêche la sortie hors img
        if (x > img.width - (w / zoom)) {x = img.width - (w / zoom);}
        if (x < w / zoom) {x = w / zoom;}
        if (y > img.height - (h / zoom)) {y = img.height - (h / zoom);}
        if (y < h / zoom) {y = h / zoom;}

        glass.style.left = (x - w) + "px";
        glass.style.top = (y - h) + "px";
        glass.style.backgroundPosition = "-" + ((x * zoom) - w + bw) + "px -" + ((y * zoom) - h + bw) + "px";
    }

    function getCursorPos(e : MouseEvent) {
        var rect, x = 0, y = 0;
        e = e || window.event;

        rect = img.getBoundingClientRect();

        x = e.pageX - rect.left;
        y = e.pageY - rect.top;

        x = x - window.pageXOffset;
        y = y - window.pageYOffset;

        return {x : x, y : y};
    }
}

function replaceProductPrices () {
    const productPricesEl = document.querySelector('.js-product-prices');

    if (!productPricesEl) {
        return;
    }

    const mobilePricesEl = document.querySelector('.js-mobile-product-prices') as HTMLElement;
    const desktopPricesEl = document.querySelector('.js-desktop-product-prices') as HTMLElement;

    let newParent = mobilePricesEl;
    let oldParent = desktopPricesEl;

    if (getBreakpoint('md') < window.innerWidth) {
        newParent = desktopPricesEl;
        oldParent = mobilePricesEl;
    }

    while (oldParent.childNodes.length > 0) {
        newParent.appendChild(oldParent.childNodes[0]);
    }
}

window.addEventListener('resize', debounce(replaceProductPrices, 100));
replaceProductPrices();

const imgZoom = createComponent(() => ({
    setup() {
        const covers = document.querySelectorAll('.js-product-cover');

        covers.forEach((item) => {
            const productZoom = item.parentNode?.querySelector('.js-product-zoom') as HTMLElement;
            const productMask = item.parentNode?.querySelector('.js-product-mask') as HTMLElement;
            const img = item as HTMLImageElement;

            magnify(img, productZoom, 1.75);

            img.addEventListener('mousemove', (e) => {
                productMask.classList.add('!opacity-50');
                productZoom.classList.add('!opacity-100');
            });
            img.addEventListener('mouseleave', () => {
                productMask.classList.remove('!opacity-50');
                productZoom.classList.remove('!opacity-100');
            });
        });
    }
}));

const imagesSlider = createComponent(() => ({
    setup() {
        const navConfig: SwiperOptions = {
            modules: [
                Navigation,
            ],
            navigation: {
                prevEl: this.$refs.navPrev,
                nextEl: this.$refs.navNext,
            },
            slidesPerView: 4,
            spaceBetween: 8,
            slideToClickedSlide: true,
            direction: 'vertical',
        }

        const coverConfig: SwiperOptions = {
            modules: [
                EffectFade,
                Navigation,
                Thumbs,
            ],
            navigation: {
                prevEl: this.$refs.coverPrev,
                nextEl: this.$refs.coverNext,
            },
            slideToClickedSlide: true,
            slidesPerView: 1,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            loop: true,
            thumbs: {
                swiper: new Swiper(this.$refs.nav, navConfig),
            },
        }

        new Swiper(this.$refs.cover, coverConfig);
    },
}));

const modal = createComponent(() => ({
    isOpened: false,

    toggle (force: boolean) {
        this.isOpened = force == undefined ? !this.isOpened : force;
    },

    setup () {
        const covers = document.querySelectorAll('.js-product-cover');
        const modalSlider = document.querySelector('.js-product-modal .swiper');

        const sliderConfig: SwiperOptions = {
            modules: [
                EffectFade,
                Navigation,
            ],
            navigation: {
                prevEl: this.$refs.sliderPrev,
                nextEl: this.$refs.sliderNext,
            },
            init: false,
            slidesPerView: 1,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
        }

        const swiper = new Swiper(this.$refs.slider, sliderConfig);

        toggleModal(this.isOpened);
        this.$watch('isOpened', toggleModal);

        covers.forEach((item) => {
            item.addEventListener('click', (e) => {
                const child = item.parentNode as HTMLElement;
                const parent = child.parentNode as HTMLElement;;
                const index = Array.prototype.indexOf.call(parent.children, child);

                toggleModal(true);
                this.toggle(true);

                if(!modalSlider?.classList.contains('swiper-initialized')) {
                    swiper.params.initialSlide = index;
                    swiper.init();
                } else {
                    swiper.slideTo(index);
                }
            });
        });
    },
}));

export default {
    imagesSlider,
    imgZoom,
    modal,
};
